<!-- https://www.figma.com/file/reAk2sU4YpRajpQu2YBOHk/007%2F1.-%D0%AD%D0%BB%D0%B5%D0%BC%D0%B5%D0%BD%D1%82%D1%8B?type=design&node-id=195-29938&t=Sf11d7jBSxY9MSdr-0 -->
<template>
  <div class="spoiler">
    <transition name="fade">
      <div
        v-show="isShowContent"
        class="spoiler__content"
      >
        <TheContent
          v-for="item of elem.children"
          :key="item.id"
          :elem="item"
        />
      </div>
    </transition>
    <div class="spoiler__button-wrapper">
      <div
        class="spoiler__button"
        @click="toggleIsShowContent"
      >
        <div class="spoiler__button-text">
          {{ buttonText }}
        </div>
        <div
          class="spoiler__button-icon"
          :class="buttonIconClasses"
        />
      </div>
    </div>
  </div>
</template>

<script lang="ts">
  import type { PropType } from 'vue';
  import TheContent from '~/components/content/TheContent';
  import type { SpoilerAttributes } from '~/types/components/Spoiler';

  export default defineNuxtComponent({
    name: 'BaseSpoiler',

    components: {
      TheContent,
    },

    props: {
      elem: {
        type: Object as PropType<TContent<SpoilerAttributes>>,
        required: true,
      },
    },

    data() {
      return {
        isShowContent: false,
      };
    },

    computed: {
      buttonIconClasses(): Record<string, boolean> {
        return {
          'spoiler__button-icon--active': this.isShowContent,
        };
      },

      attributes(): SpoilerAttributes {
        return this.elem.attributes;
      },

      buttonText(): string | undefined {
        return this.isShowContent ? this.attributes.title_close : this.attributes.title;
      },
    },

    methods: {
      toggleIsShowContent(): void {
        this.isShowContent = !this.isShowContent;
      },
    },
  });
</script>

<style lang="scss" scoped>
  .spoiler {
    margin: 24px 0;
    border: 1px solid #ebebeb;
    border-left: none;
    border-right: none;
    padding: 16px 0;

    &__title {
      text-align: center;
      color: black;
      @include mediumText;
      font-weight: 700;
      margin-bottom: 8px;

      @include tablet {
        @include extraBigText;
      }
    }

    &__button {
      @include fontTextBtn;

      display: flex;
      align-items: center;
      color: var(--main-color-2);
      cursor: pointer;
      user-select: none;

      @include hover {
        text-decoration: underline;
        text-underline-offset: 6px;
      }

      &-icon {
        width: 16px;
        height: 16px;
        background-color: var(--main-color-2);
        margin-left: 4px;
        @include dropdownMask;

        &--active {
          rotate: 180deg;
        }
      }
    }

    &__content {
      margin-bottom: 16px;

      p:not(:last-child) {
        margin-bottom: 24px;
      }
    }
  }
</style>
